module.exports = __webpack_public_path__ + "static/media/lego-head-500.e981b874.svg";